<template>
  <div class="checkout-data-detail-box">
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-content>
          <div class="py-3 text-left">
            <div style="font-size: 20px; margin-bottom: 10px;">
              {{ $t('accounting_product.type_of_list') }} :
              <span class="text-red-500" v-if="contrctCheckOutTemp.isEscaped">{{ $t('contract.escaped') }}</span>
              <span class="text-red-500" v-else-if="contrctCheckOutTemp.isCloseContract">{{ $t('contract.close_contract') }}</span>
              <span v-else class="text-yellow-500">{{ $t('contract.reduce_area') }}</span>
            </div>
            <div style="font-size: 16px;">
              {{ $t('market.market_title') }} :
              <span class="text-picton-blue-600">
                {{
                  contrctCheckOutTemp.areas
                  ? contrctCheckOutTemp.areas.map((i) => i.name).join(", ")
                  : "-"
                }}
              </span>
            </div>
          </div>
          <div class="checkout-data-detail-invoice deposit"
            v-if="contrctCheckOutTemp.depositInvoices && contrctCheckOutTemp.depositInvoices.length && contrctCheckOutTemp.depositTotalCost > 0">
            <div class="header">{{ $t('payment.deposit_cost') }}</div>
            <div class="invoice-box" v-for="(depositInvoice, index) in contrctCheckOutTemp.depositInvoices">
              <div class="invoice">
                {{ index + 1 }}.
                {{ $t('invoice.invoice_number', { id: depositInvoice.documentId }) }}
                {{ $t('payment.total_amount_message', { count: $helper.toCurrency(invoiceMainCurrency(depositInvoice.invoice).totalValue) }) }}
              </div>
              <template
                v-if="depositInvoice.invoice && depositInvoice.invoice.receipts && depositInvoice.invoice.receipts.length">
                <div v-for="receipt in  depositInvoice.invoice.receipts" class="receipt-box">
                  <div :class="`${receipt.isPaid ? '' : 'red-status'}`">
                    <span :class="`${receipt.isPaid ? '' : 'unpaid'}`">
                      -
                      {{ $t('payment.receipt_number', { id: receipt.documentId }) }}
                      <span v-if="receipt.sumPaidReceipt > 0">
                        {{ $t('payment.total_amount_message', { count: $helper.toCurrency(receipt.sumPaidReceipt) }) }}
                      </span>
                      ({{ receipt.paymentMethodText }})
                    </span>
                    <span v-if="!receipt.isPaid">({{ $t('payment.cancel_payment') }})</span>
                  </div>
                </div>
              </template>
              <div v-if="depositInvoice.paymentClass" :class="`summary-box ${depositInvoice.paymentClass.cssClass}`">
                {{ $t('invoice.invoice_status') }} : <b>{{ depositInvoice.paymentClass.text }}</b> 
                <span v-if="depositInvoice.totalUnPaidValue > 0">{{ $t('payment.pending') }} : {{ depositInvoice.totalUnPaidValue | currencySuffixTextThEn }}</span>
              </div>
            </div>
            <div class="total-box">
              <span class="header">
                {{ $t('payment.total_deposit') }} {{ contrctCheckOutTemp.depositInvoices.length }} {{ $t('bill.bill') }}
              </span>:
              <span class="blue-status">
                {{ contrctCheckOutTemp.depositTotalCostReceipt | currencySuffixTextThEn }}
              </span>
            </div>
          </div>
          <div class="checkout-data-detail-invoice forfeit"
            v-if="contrctCheckOutTemp.isForfeit && contrctCheckOutTemp.forfeitCost > 0">
            <div class="header">{{ $t('payment.forfeit_deposit') }}</div>
            <div class="invoice-box">
              <div class="invoice">
                - {{ $t('payment.total_amount_message', { count: $helper.toCurrency(contrctCheckOutTemp.forfeitCost) }) }}
              </div>
              <div class="summary-box">
                {{ $t('payment.reason_forfeit_deposit') }} :
                <b v-if="contrctCheckOutTemp.isEscaped">{{ $t('contract.escaped') }}</b> 
                <b v-else>{{ contrctCheckOutTemp.forfeitNote || '-' }}</b>
              </div>
            </div>
            <div class="total-box">
              <span class="header">
                {{ $t('payment.total_remain_deposit') }}
              </span>:
              <span class="orange-status">
                {{ (contrctCheckOutTemp.depositTotalCostReceipt - contrctCheckOutTemp.forfeitCost) | currencySuffixTextThEn }}
              </span>
            </div>
          </div>
          <div class="checkout-data-detail-invoice"
            v-if="contrctCheckOutTemp.unpaidInvoices && contrctCheckOutTemp.unpaidInvoices.length">
            <div class="header">{{ $t('bill.pending_bill') }}</div>
            <div class="invoice-box" v-for="(unpaidInvoice, index) in contrctCheckOutTemp.unpaidInvoices">
              <div class="invoice">
                {{ index + 1 }}.
                {{ $t('invoice.invoice_number', { id: unpaidInvoice.documentId }) }}
                {{ $t('payment.total_amount_message', { count: $helper.toCurrency(invoiceMainCurrency(unpaidInvoice.invoice).totalValue) }) }}
              </div>
              <template
                v-if="unpaidInvoice.invoice && unpaidInvoice.invoice.receipts && unpaidInvoice.invoice.receipts.length">
                <div v-for="receipt in  unpaidInvoice.invoice.receipts" class="receipt-box">
                  <div :class="`${receipt.isPaid ? '' : 'red-status'}`" v-if="receipt.sumPaidReceipt > 0">
                    <span :class="`${receipt.isPaid ? '' : 'unpaid'}`">
                      -
                      {{ $t('payment.receipt_number', { id: receipt.documentId }) }}
                      {{ $t('payment.total_amount_message', { count: $helper.toCurrency(receipt.sumPaidReceipt) }) }}
                      ({{ receipt.paymentMethodText }})
                    </span>
                    <span v-if="!receipt.isPaid">({{ $t('payment.cancel_payment') }})</span>
                  </div>
                </div>
              </template>
              <div v-if="unpaidInvoice.paymentClass" :class="`summary-box ${unpaidInvoice.paymentClass.cssClass}`">
                {{ $t('invoice.invoice_status') }} : <b>{{ unpaidInvoice.paymentClass.text }}</b>
                <span v-if="unpaidInvoice.totalUnPaidValue > 0" class="red-status pl-2">
                  {{ contrctCheckOutTemp.isEscaped ? $t('bill.bad_debt') : $t('payment.pending') }} : 
                  {{ unpaidInvoice.totalUnPaidValue | currencySuffixTextThEn }}</span>
              </div>
            </div>
            <div
              :class="`total-box ${contrctCheckOutTemp.unpaidTotalCostPaymentClass ? contrctCheckOutTemp.unpaidTotalCostPaymentClass.cssClass : ''}`">
              <span class="header">
                {{ contrctCheckOutTemp.isEscaped ? $t('bill.total_invoice_bad_debt_bill') : $t('bill.total_invoice_bill') }} 
                {{ contrctCheckOutTemp.unpaidInvoices.length }} {{ $t('bill.bill') }}
              </span>:
              <span v-if="contrctCheckOutTemp.unpaidTotalCostPaymentClass">
                <b>
                  {{ contrctCheckOutTemp.unpaidTotalCostPaymentClass.text }}
                </b>
              </span>
              <span class="red-status" v-if="contrctCheckOutTemp.unpaidTotalCostReceipt > 0">
                <b>
                  {{ contrctCheckOutTemp.unpaidTotalCostReceipt | currencySuffixTextThEn }}
                </b>
              </span>
            </div>
          </div>
          <div class="checkout-data-detail-invoice"
            v-if="contrctCheckOutTemp.checkOutInvoices && contrctCheckOutTemp.checkOutInvoices.length">
            <div class="header">{{ $t('bill.checkout_bill') }}</div>
            <div class="invoice-box" v-for="(checkOutInvoice, index) in contrctCheckOutTemp.checkOutInvoices">
              <div class="invoice">
                {{ index + 1 }}.
                {{ $t('invoice.invoice_number', { id: checkOutInvoice.documentId }) }}
                {{ $t('payment.total_amount_message', { count: $helper.toCurrency(invoiceMainCurrency(checkOutInvoice.invoice).totalValue) }) }}
              </div>
              <template
                v-if="checkOutInvoice.invoice && checkOutInvoice.invoice.receipts && checkOutInvoice.invoice.receipts.length">
                <div v-for="receipt in  checkOutInvoice.invoice.receipts" class="receipt-box">
                  <div :class="`${receipt.isPaid ? '' : 'red-status'}`" v-if="receipt.sumPaidReceipt > 0">
                    <span :class="`${receipt.isPaid ? '' : 'unpaid'}`">
                      -
                      {{ $t('payment.receipt_number', { id: receipt.documentId }) }}
                      {{ $t('payment.total_amount_message', { count: $helper.toCurrency(receipt.sumPaidReceipt) }) }}
                      ({{ receipt.paymentMethodText }})
                    </span>
                    <span v-if="!receipt.isPaid">({{ $t('payment.cancel_payment') }})</span>
                  </div>
                </div>
              </template>
              <div v-if="checkOutInvoice.paymentClass" :class="`summary-box ${checkOutInvoice.paymentClass.cssClass}`">
                {{ $t('invoice.invoice_status') }} : <b>{{ checkOutInvoice.paymentClass.text }}</b>
                <span v-if="checkOutInvoice.totalUnPaidValue > 0" class="red-status pl-2">
                  {{ contrctCheckOutTemp.isEscaped ? $t('bill.bad_debt') : $t('payment.pending') }} : 
                  {{ checkOutInvoice.totalUnPaidValue | currencySuffixTextThEn }}</span>
              </div>
            </div>
            <div
              :class="`total-box ${contrctCheckOutTemp.checkOutTotalCostPaymentClass ? contrctCheckOutTemp.checkOutTotalCostPaymentClass.cssClass : ''}`">
              <span class="header">
                {{ contrctCheckOutTemp.isEscaped ? $t('bill.total_checkout_bad_debt_bill') : $t('bill.total_checkout_bill') }} 
                {{ contrctCheckOutTemp.checkOutInvoices.length }} {{ $t('bill.bill') }}
              </span>:
              <span v-if="contrctCheckOutTemp.checkOutTotalCostPaymentClass">
                <b>
                  {{ contrctCheckOutTemp.checkOutTotalCostPaymentClass.text }}
                </b>
              </span>
              <span v-if="contrctCheckOutTemp.checkOutTotalCostReceipt > 0">
                {{ contrctCheckOutTemp.checkOutTotalCostReceipt | currencySuffixTextThEn }}
              </span>
            </div>
          </div>
          <div class="summary-total">
            <div v-if="contrctCheckOutTemp.depositTotalCost > 0" class="blue-status">
              {{ $t('payment.total_all_deposit') }} : {{ contrctCheckOutTemp.depositTotalCost | currencySuffixTextThEn }}
            </div>
            <div v-if="contrctCheckOutTemp.isForfeit && contrctCheckOutTemp.forfeitCost > 0" class="orange-status">
              {{ $t('payment.forfeit_deposit_money') }} : {{ contrctCheckOutTemp.forfeitCost | currencySuffixTextThEn }}
            </div>
            <div v-if="contrctCheckOutTemp.totalUnPaidAndCheckOutTotalCost > 0" class="red-status">
              {{ contrctCheckOutTemp.isEscaped ? $t('payment.total_all_pending_payment_bad_debt') : $t('payment.total_all_pending_payment') }} : {{ contrctCheckOutTemp.totalUnPaidAndCheckOutTotalCost | currencySuffixTextThEn }}
              <span v-if="contrctCheckOutTemp.totalDepositReceipt > 0" class="blue-status">
                ({{ $t('payment.deduct_deposit') }} {{ contrctCheckOutTemp.totalDepositReceipt | currencySuffixTextThEn }})
              </span>
            </div>
            <div v-if="contrctCheckOutTemp.totalOtherReceipt > 0" class="green-status">
              {{ $t('payment.total_all_seller_payment') }} : {{ contrctCheckOutTemp.totalOtherReceipt | currencySuffixTextThEn }}
            </div>
            <div class="pt-5 red-status"> <b>
                {{ contrctCheckOutTemp.isEscaped ? $t('payment.remaining_pending_payment_bad_debt') : $t('payment.remaining_pending_payment') }} : {{ contrctCheckOutTemp.totalUnPaidReceipt | currencySuffixTextThEn }}</b>
            </div>
            <div class="blue-status"><b>
                {{ $t('payment.remaining_deposit') }} : {{ contrctCheckOutTemp.totalDepositBalance | currencySuffixTextThEn }}</b>
            </div>
          </div>
        </v-expansion-panel-content>
        <v-expansion-panel-header hide-actions class="pb-0 pt-1" style="height: 30px !important; min-height: 30px !important;">
          <template v-slot:default="{ open }">
            <div class="text-gray-500">
              {{ `${$t('show')}${$t('detail')}` }}
              <v-icon>
                <template v-if="open">mdi-chevron-up</template>
                <template v-else>mdi-chevron-down</template>
              </v-icon>
            </div>
          </template>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DocumentItem, Invoice } from "../classes";
export default {
  computed: {
    ...mapGetters({
      contrctCheckOut: "contractCheckout/contractCheckout",
    }),
  },
  watch: {
    contrctCheckOut: {
      handler(ccs) {
        if (ccs)
          this.contrctCheckOutTemp = this.initData({ ...ccs })
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      calCulateInvoice: {
        total: 0,
        text: '',
        cssClass: ''
      },
      contrctCheckOutTemp: null
    };
  },
  created() {
    // this.initData();
  },
  methods: {
    initData(inputContractCheckout) {
      let contrctCheckOut = JSON.parse(JSON.stringify(inputContractCheckout))
      const paymentClass = {
        paid: {
          text: this.$t('payment.partial_payment'),
          cssClass: 'blue-status',
        },
        paided: {
          text: this.$t('payment.paid'),
          cssClass: 'green-status',
        },
        unpaid: {
          text: '',
          cssClass: 'red-status',
        }
      }
      if (contrctCheckOut) {
        let total = 0
        contrctCheckOut.totalUnPaidAndCheckOutTotalCost = contrctCheckOut.checkOutTotalCost + contrctCheckOut.unpaidTotalCost
        contrctCheckOut.totalUnPaidReceipt = 0
        contrctCheckOut.totalUnPaidBalance = 0
        contrctCheckOut.totalDepositReceipt = 0
        contrctCheckOut.totalDepositBalance = 0
        contrctCheckOut.totalOtherReceipt = 0
        contrctCheckOut.totalRefundCost = 0
        let currencyRate = contrctCheckOut.currencyRate
        let currencyCode = contrctCheckOut.currencyCode
        if (contrctCheckOut.depositInvoices) {
          contrctCheckOut.depositTotalCostReceipt = 0
          contrctCheckOut.depositTotalCostUnpaid = 0
          for (let depositInvoice of contrctCheckOut.depositInvoices) {
            depositInvoice.totalUnPaidValue = depositInvoice.totalValue || 0
            depositInvoice.sumPaidReceipt = 0
            if (depositInvoice.invoice?.receipts?.length) {
              for (let receipt of depositInvoice.invoice.receipts) {
                let exchangeRateToMainCurrency = 1
                if (receipt.currencyCode != currencyCode) {
                  exchangeRateToMainCurrency = currencyRate?.data[receipt.currencyCode][currencyCode]?.value || 0
                }
                receipt.sumPaidReceipt = 0
                receipt.items = receipt.items.map(i => new DocumentItem(i, i.isVatInclusive, i.vatPercent, null, null, exchangeRateToMainCurrency))
                if (receipt.isPaid)
                  for (const item of receipt.items) {
                    let area = item.area
                    let areaLists = contrctCheckOut.areas.map(a => a.objectId)
                    if (contrctCheckOut.isCloseContract) {
                      if (!area || (area && !area.objectId) || (area && areaLists?.length && areaLists.indexOf(area.objectId) > -1)) {
                        receipt.sumPaidReceipt += item.totalValue
                        depositInvoice.sumPaidReceipt += item.totalValue
                      }
                    } else {
                      if (area && areaLists?.length && areaLists.indexOf(area.objectId) > -1) {
                        receipt.sumPaidReceipt += item.totalValue
                        depositInvoice.sumPaidReceipt += item.totalValue
                      }
                    }
                  }
              }
              depositInvoice.totalUnPaidValue = depositInvoice.totalValue - depositInvoice.sumPaidReceipt
            }
            if (depositInvoice.totalUnPaidValue > 0 && depositInvoice.sumPaidReceipt > 0) {
              depositInvoice.paymentClass = paymentClass.paid
            } else if (depositInvoice.totalUnPaidValue > 0 && depositInvoice.sumPaidReceipt == 0) {
              depositInvoice.paymentClass = paymentClass.unpaid
            } else if (depositInvoice.totalUnPaidValue <= 0) {
              depositInvoice.paymentClass = paymentClass.paided
            }
            contrctCheckOut.depositTotalCostReceipt += depositInvoice.sumPaidReceipt
            contrctCheckOut.depositTotalCostUnpaid += depositInvoice.totalUnPaidValue
          }
          if (contrctCheckOut.depositTotalCostUnpaid > 0) {
            contrctCheckOut.depositTotalCostPaymentClass = paymentClass.unpaid
          } else {
            contrctCheckOut.depositTotalCostPaymentClass = paymentClass.paided
          }
        }
        if (contrctCheckOut.creditNotes) {
          for (let creditNote of contrctCheckOut.creditNotes) {
            contrctCheckOut.totalRefundCost += creditNote.totalValue
          }
          contrctCheckOut.totalRefundCost = contrctCheckOut.depositTotalCostReceipt - contrctCheckOut.totalRefundCost
        }
        if (contrctCheckOut.unpaidInvoices) {
          contrctCheckOut.unpaidTotalCostReceipt = 0
          for (let unpaidInvoice of contrctCheckOut.unpaidInvoices) {
            unpaidInvoice.totalUnPaidValue = unpaidInvoice.totalValue || 0
            unpaidInvoice.sumPaidReceipt = 0
            if (unpaidInvoice.invoice?.receipts?.length && unpaidInvoice.totalValue > 0) {
              for (let receipt of unpaidInvoice.invoice.receipts) {
                let exchangeRateToMainCurrency = 1
                if (receipt.currencyCode != currencyCode) {
                  exchangeRateToMainCurrency = currencyRate?.data[receipt.currencyCode][currencyCode]?.value || 0
                }
                receipt.sumPaidReceipt = 0
                receipt.items = receipt.items.map(i => new DocumentItem(i, i.isVatInclusive, i.vatPercent, null, null, exchangeRateToMainCurrency))
                if (receipt.isPaid) {
                  for (const item of receipt.items) {
                    let area = item.area
                    let areaLists = contrctCheckOut.areas.map(a => a.objectId)
                    if (contrctCheckOut.isCloseContract) {
                      if (!area || (area && areaLists?.length && areaLists.indexOf(area.objectId) > -1)) {
                        receipt.sumPaidReceipt += item.totalValue
                        unpaidInvoice.sumPaidReceipt += item.totalValue
                        if (receipt.paymentMethod == 5)
                          contrctCheckOut.totalDepositReceipt += item.totalValue
                        else contrctCheckOut.totalOtherReceipt += item.totalValue
                      }
                    } else {
                      if (area && areaLists?.length && areaLists.indexOf(area.objectId) > -1) {
                        receipt.sumPaidReceipt += item.totalValue
                        unpaidInvoice.sumPaidReceipt += item.totalValue
                        if (receipt.paymentMethod == 5)
                          contrctCheckOut.totalDepositReceipt += item.totalValue
                        else contrctCheckOut.totalOtherReceipt += item.totalValue
                      }
                    }
                  }
                }
              }
              unpaidInvoice.totalUnPaidValue = unpaidInvoice.totalValue
            }
            if (unpaidInvoice.totalUnPaidValue > 0 && unpaidInvoice.sumPaidReceipt > 0) {
              unpaidInvoice.paymentClass = paymentClass.paid
            } else if (unpaidInvoice.totalUnPaidValue > 0 && unpaidInvoice.sumPaidReceipt == 0) {
              unpaidInvoice.paymentClass = paymentClass.unpaid
            } else if (unpaidInvoice.totalUnPaidValue <= 0) {
              unpaidInvoice.paymentClass = paymentClass.paided
            }
            contrctCheckOut.unpaidTotalCostReceipt += unpaidInvoice.totalUnPaidValue
          }
          if (contrctCheckOut.unpaidTotalCostReceipt > 0) {
            contrctCheckOut.unpaidTotalCostPaymentClass = paymentClass.unpaid
          } else {
            contrctCheckOut.unpaidTotalCostPaymentClass = paymentClass.paided
          }
          contrctCheckOut.totalUnPaidReceipt += contrctCheckOut.unpaidTotalCostReceipt
        }
        if (contrctCheckOut.checkOutInvoices) {
          contrctCheckOut.checkOutTotalCostReceipt = 0
          for (let checkOutInvoice of contrctCheckOut.checkOutInvoices) {
            checkOutInvoice.totalUnPaidValue = checkOutInvoice.totalValue || 0
            checkOutInvoice.sumPaidReceipt = 0
            if (checkOutInvoice.invoice?.receipts?.length && checkOutInvoice.totalValue > 0) {
              for (let receipt of checkOutInvoice.invoice.receipts) {
                let exchangeRateToMainCurrency = 1
                if (receipt.currencyCode != currencyCode) {
                  exchangeRateToMainCurrency = currencyRate?.data[receipt.currencyCode][currencyCode]?.value || 0
                }
                receipt.sumPaidReceipt = 0
                receipt.items = receipt.items.map(i => new DocumentItem(i, i.isVatInclusive, i.vatPercent, null, null, exchangeRateToMainCurrency))
                if (receipt.isPaid) {
                  for (const item of receipt.items) {
                    let area = item.area
                    let areaLists = contrctCheckOut.areas.map(a => a.objectId)
                    if (contrctCheckOut.isCloseContract) {
                      if (!area || (area && areaLists?.length && areaLists.indexOf(area.objectId) > -1)) {
                        receipt.sumPaidReceipt += item.totalValue
                        checkOutInvoice.sumPaidReceipt += item.totalValue
                        if (receipt.paymentMethod == 5)
                          contrctCheckOut.totalDepositReceipt += item.totalValue
                        else contrctCheckOut.totalOtherReceipt += item.totalValue
                      }
                    } else {
                      if (area && areaLists?.length && areaLists.indexOf(area.objectId) > -1) {
                        receipt.sumPaidReceipt += item.totalValue
                        checkOutInvoice.sumPaidReceipt += item.totalValue
                        if (receipt.paymentMethod == 5)
                          contrctCheckOut.totalDepositReceipt += item.totalValue
                        else contrctCheckOut.totalOtherReceipt += item.totalValue
                      }
                    }

                  }
                }
              }
              checkOutInvoice.totalUnPaidValue = checkOutInvoice.totalValue
            }
            if (checkOutInvoice.totalUnPaidValue > 0 && checkOutInvoice.sumPaidReceipt > 0) {
              checkOutInvoice.paymentClass = paymentClass.paid
            } else if (checkOutInvoice.totalUnPaidValue > 0 && checkOutInvoice.sumPaidReceipt == 0) {
              checkOutInvoice.paymentClass = paymentClass.unpaid
            } else if (checkOutInvoice.totalUnPaidValue <= 0) {
              checkOutInvoice.paymentClass = paymentClass.paided
            }
            contrctCheckOut.checkOutTotalCostReceipt += checkOutInvoice.totalUnPaidValue
          }
          if (contrctCheckOut.checkOutTotalCostReceipt > 0) {
            contrctCheckOut.checkOutTotalCostPaymentClass = paymentClass.unpaid
          } else {
            contrctCheckOut.checkOutTotalCostPaymentClass = paymentClass.paided
          }
          contrctCheckOut.totalUnPaidReceipt += contrctCheckOut.checkOutTotalCostReceipt
          // contrctCheckOut.totalDepositReceipt -= contrctCheckOut.checkOutTotalCostReceipt
        }
        total = contrctCheckOut.totalUnPaidAndCheckOutTotalCost - (contrctCheckOut.depositTotalCostReceipt - (contrctCheckOut.isForfeit ? parseFloat(contrctCheckOut.forfeitCost) : 0)) //- contrctCheckOut.totalOtherReceipt
        contrctCheckOut.totalDepositBalance = contrctCheckOut.depositTotalCostReceipt - contrctCheckOut.totalDepositReceipt - (contrctCheckOut.isForfeit ? parseFloat(contrctCheckOut.forfeitCost) : 0)
        contrctCheckOut.totalUnPaidBalance = contrctCheckOut.unpaidTotalCostReceipt - contrctCheckOut.totalDepositReceipt
        if (total > 0) {
          this.calCulateInvoice.total = total
          this.calCulateInvoice.text = this.$t('payment.collect_customer_money')
          this.calCulateInvoice.cssClass = 'red-box'
        } else if (total < 0) {
          this.calCulateInvoice.total = Math.abs(total)
          this.calCulateInvoice.text = this.$t('payment.refund_customer_money')
          this.calCulateInvoice.cssClass = 'blue-box'
        } else {
          this.calCulateInvoice.total = 0
          this.calCulateInvoice.text = this.$t('payment.no_expense')
          this.calCulateInvoice.cssClass = 'green-box'
        }

      }
      return contrctCheckOut
    },
    invoiceMainCurrency(invoice) {
      return new Invoice(invoice, true)
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-data-detail-box {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-size: 18px;
  margin-top: 15px;

  .checkout-data-detail-invoice {
    color: rgba(220, 38, 38, 1);
    text-align: left;
    padding-bottom: 20px;

    div.header {
      font-weight: bold;
      padding-bottom: 5px;
    }

    .invoice-box {
      .invoice {}

      .receipt-box {
        padding-left: 20px;
        color: rgba(100, 179, 53, 1);
      }

      .summary-box {
        padding-left: 50px;
        padding-bottom: 10px;
        padding-top: 5px;
        text-decoration: underline;
      }
    }

    .total-box {
      padding: 10px;

      span {
        text-decoration-line: underline;
        text-decoration-style: double;
      }

      span.header {
        color: rgba(0, 0, 0, 0.8);
        margin-right: 5px;
      }
    }
  }

  .checkout-data-detail-invoice.deposit {
    color: rgba(61, 178, 255, 1);
    // background: rgba(61, 178, 255, 0.05);
    // border: 2px solid rgba(61, 178, 255, 1);
    // border-radius: 10px;
    // padding: 15px 30px;
  }

  .checkout-data-detail-invoice.forfeit {
    color: var(--v-warning-base);
  }
}

.checkout-data-detail-box.red-box {
  //.text-red-600
  color: rgba(220, 38, 38, 1);
  border-color: rgba(220, 38, 38, 1);
  background: rgba(220, 38, 38, 0.05);
}

.summary-total {
  font-size: 20px;

  div {
    padding: 5px;
  }
}

.summary-tail {
  font-size: 25px;
  font-weight: bold;
  padding-top: 20px;
}

.red-status {
  color: rgba(220, 38, 38, 1);
}

.checkout-data-detail-box.green-box {
  //.text-screamin-green-700
  color: rgba(100, 179, 53, 1);
  border-color: rgba(100, 179, 53, 1);
  background: rgba(100, 179, 53, 0.05);
}

.green-status {
  //.text-screamin-green-700
  color: rgba(100, 179, 53, 1);
}

.checkout-data-detail-box.blue-box {
  //.text-picton-blue-500
  color: rgba(61, 178, 255, 1);
  border-color: rgba(61, 178, 255, 1);
  background: rgba(61, 178, 255, 0.05);
}

.blue-status {
  //.text-picton-blue-500
  color: rgba(61, 178, 255, 1);
}

.orange-status {
  color: var(--v-warning-base)
}

.unpaid {
  text-decoration: line-through;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: unset;
}

.v-expansion-panel::before {
  box-shadow: none;
}

.v-application--is-ltr .v-expansion-panel-header {
  text-align: center;
}
</style>